import type { ISpread } from "../../spreadsSlice";

export const situationPotentialSpread: ISpread = {
  id: "spread_situation_potential",
  name: "Ситуация и её потенциал",
  altNames: ["Situation and Potential Spread"],
  purpose:
    "Анализ настоящего состояния ситуации, скрытых возможностей и вероятного результата при сохранении текущей динамики.",
  cardsCount: 3,
  layout: "[1]   [2]   [3]",
  positions: [
    {
      id: "situation",
      title: "Суть ситуации",
      meaning: "Основная энергия и текущее состояние события.",
    },
    {
      id: "hidden_potential",
      title: "Скрытый потенциал",
      meaning: "Возможности, которые пока ещё не проявились.",
    },
    {
      id: "probable_result",
      title: "Вероятный результат",
      meaning:
        "Направление развития ситуации, если текущие условия сохранятся.",
    },
  ],
  symbolism:
    "Три позиции отражают проявленное, скрытое и потенциальное: текущее состояние, возможность и направление её реализации.",
  archetypes: ["Проявленное", "Скрытое", "Потенциальное"],
  psychology:
    "Помогает увидеть неочевидные возможности и понять, как настоящее состояние содержит потенциальное направление будущего.",
  procedure: {
    preparation:
      "Сформулировать вопрос о том, как развивается текущая ситуация.",
    steps:
      "Перетасовать колоду; выложить три карты слева направо; сначала прочитать каждую позицию отдельно, затем рассмотреть все три карты как единый процесс.",
  },
  interpretations: [
    "Первая карта показывает уже проявленную сторону ситуации.",
    "Вторая карта раскрывает скрытую возможность, которая может оказаться важнее очевидного результата.",
    "Третья карта показывает направление развития при сохранении текущей динамики.",
  ],
  nuances: [
    "Скрытый потенциал может сначала казаться не связанным с текущей ситуацией.",
    "Вероятный результат является направлением, а не фиксированным приговором.",
    "Осознанное использование скрытого потенциала может изменить дальнейшее развитие.",
  ],
  examples: [
    {
      cards: ["7 Пентаклей", "Звезда", "Колесо Фортуны"],
      interpretation:
        "Текущее ожидание и подготовка содержат скрытый потенциал надежды и восстановления; дальнейшее развитие может привести к значительным переменам.",
    },
  ],
  selfQuestions: [
    "Что в этой ситуации уже проявлено?",
    "Какие скрытые ресурсы я игнорирую?",
    "Что случится, если ничего не изменю?",
  ],
};

